import moment from 'moment'

export const formatDate = date =>
  date && moment(date).format('HH:mm:ss D/M/YYYY')

export const formatTime = time => moment(time, 'H:m:s').format('HH:mm')
